import React, { useState, useCallback } from 'react';
import { View, Text } from 'react-native'
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons'
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { QUICKBOOKS_IMPORT } from './queries';
import { useMutation } from '@apollo/client';

import { cardStyles as styles } from '../../Reports';

const TrialBalanceImport = ({refetch}) => {
  const [date, setDate] = useState(
    moment().format('YYYY-MM-DD')
  );
  const [file, setFile] = useState();
  const [importing, setImporting] = useState(false);

  const [quickbooksImport] = useMutation(QUICKBOOKS_IMPORT, {
    onCompleted: () => {
      refetch();
      setImporting(false);
    }
  });

  const handleSubmit = () => {
    setImporting(true);
    let variables = {
      name: `Trial Balance Import ${moment().format('MM-DD-YYYY h:mm:ss a')}`,
      ownerType: 'QuickbooksTrialBalance',
      ownerId: 0,
      file: file,
    }
    quickbooksImport({ variables: variables });
  }

  const handleFiles = ({ target }) => {
    setFile(target.files[0])
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Quickbooks Trial Balance Import</Text>
      <input
        type="file"
        id='trial-balance-input'
        onChange={e => handleFiles({ target: e.target })}
        style={{ display: 'none' }}
      />
      <label htmlFor='trial-balance-input'>
        {`Quickbooks Trial Balance Import File`}{' '}
        <FontAwesomeIcon icon={faPlusCircle} />
        <Text style={{marginLeft: '20px'}}>
          { file?.name }
        </Text>
      </label>
      <Text style={{...styles.label, marginTop: '10px'}}>Date:</Text>
      <input
        style={styles.select}
        onChange={e => setDate(e.target.value)}
        value={date || ''}
        type="date"
      />
      <ButtonGroup>
        <Button
          label={importing ? "Importing..." : "Import"} onPress={() => handleSubmit()}
          disabled={!(file && date) || importing}
        />
      </ButtonGroup>
    </View>
  )
}

export default TrialBalanceImport;
